import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import LeadCompany from './LeadCompanyModel';
import LeadProfile from './LeadProfileModel';
import LeadSearch from './LeadSearchModel';
import LeadMatches from './LeadMatchModel';

const LeadRecord = Record({
  company: null,
  search: null,
  matches: null,
  profile: null,
});

export default class Lead extends LeadRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined') {
      return undefined;
    }

    const mapProperties = {
      company: LeadCompany.deserialize,
      matches: Hydrator.fromList(LeadMatches.deserialize),
      profile: LeadProfile.deserialize,
      search: LeadSearch.deserialize,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new Lead(hydrated);
  }
}
